<div class="container">
    <h1>{{"finishSurveyTitle" | translate}}</h1>
<!--    <h3>{{"finishSurveyParagraph" | translate}}</h3>-->
<!--    <h1>{{counter}}</h1>-->
</div>
